export enum wrapperColor{
  dbl_claro='dbl_claro',
  claro='claro',
  col_claro='col_claro',
  colorado='colorado',
  col_maduro='col_maduro',
  maduro='maduro',
  oscuro='oscuro'
};
